import { Col, Row } from "react-bootstrap";
import Physician from "../../../Physician/Models/Physician";
import React, { Fragment } from "react";
import { AbccAssessment, AbccAssessmentStatus } from "../Models/CCAssessment";
import { EnrollmentCertificate } from "../../../Physician/Models/CCEnrollment";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";
import { Certificate } from "../../../Physician/Models/Certificate";


interface IProps{
    physician: Physician;
    abccAssessments: AbccAssessment[];
    showNotMeeting: boolean;
}

export default function CCBlockSummaryAssessmentCard(props: IProps) {
    const nbsp = '\u00A0';
    var certificates = props.physician.certificates;

    const getCertificateFromEnrollmentCertificate = (enrollmentCertificate: EnrollmentCertificate) => {
        return certificates.find((cert: Certificate) => cert.certificateId == enrollmentCertificate.certificateId);
    }

    const getPathwayName = (enrollmentCertificate: EnrollmentCertificate) => {
        return enrollmentCertificate.ccAssessmentType === 1 ? "ABCC" : "Exam";
    }

    const getDueByYear = (enrollmentCertificate: EnrollmentCertificate) => {
        const certificate = getCertificateFromEnrollmentCertificate(enrollmentCertificate);

        if (enrollmentCertificate.ccAssessmentType === 1) {
            // Get Current Module End Date
            const matches = (props.abccAssessments ?? []).filter(abcc =>
                abcc?.certificateId === certificate?.certificateId &&
                getDateWithOffset(abcc.startDate) <= new Date() &&
                getDateWithOffset(abcc.endDate)   >= new Date()
              );
              
            const currentAbccAssessment = matches[0] ?? null;
            if (currentAbccAssessment == null) {
                return null;
            }

            const currentModule = currentAbccAssessment.modules.find(module => getDateWithOffset(module.startDate) <= new Date() 
                            && getDateWithOffset(module.endDate)   >= new Date());

            if (currentModule == null) {
                return null;
            }
            
            const date = getDateWithOffset(currentModule.endDate);
            return date?.getFullYear() ?? null;
        }
        else{
            if (!certificate?.expirationDate) {
                return null;
              }
              
              const date = getDateWithOffset(certificate.expirationDate);
              return date?.getFullYear() ?? null;
        }   

    };
    
    return (
        <Fragment>
            <div className="ccenrollment-summary-padding">
                <div className="ccenrollment-summary-border" style={{background: '#fff'}}>
                    <Row className="ccenrollment-summary-cert">
                        <Col>
                            <Row className="ccenrollment-certificate-header">
                                <Col>
                                    <div className="mb-0 font-weight-bolder card-title pp-font-size-small text-center">Assessments</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center">
                            <div className="pp-font-size-smaller">
                                <b>{nbsp}Certification</b>
                            </div>
                        </Col>
                        <Col className="text-center">
                            <div className="pp-font-size-smaller">
                                <b>Pathway</b>
                            </div>
                        </Col>
                        <Col className="text-right">
                            <div className="pp-font-size-smaller">
                                <b>Pass By{nbsp}{nbsp}{nbsp}{nbsp}</b>
                            </div>
                        </Col>
                    </Row>
                    { !props.showNotMeeting ? 
                        <div className="ccenrollment-summary-scrolling"> 
                            {props.physician.currentCCEnrollment.activeEnrollmentCertificates.map((enrollmentCertificate: EnrollmentCertificate) => {
                                let certificate = getCertificateFromEnrollmentCertificate(enrollmentCertificate);
                                return(
                                    <Row>
                                        <Col className="text-center">
                                            <div className="pp-font-size-smaller">
                                                <span>{certificate.certificationName}</span>
                                            </div>
                                        </Col>
                                        <Col className="text-center">
                                            <div className="pp-font-size-smaller">
                                                <span>{getPathwayName(enrollmentCertificate)}</span>
                                            </div>
                                        </Col>
                                        <Col className="text-right">
                                            <div className="pp-font-size-smaller">
                                                <span>{getDueByYear(enrollmentCertificate)}{nbsp}{nbsp}{nbsp}{nbsp}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                )})
                            }
                        </div>
                    :
                        <div className="ccenrollment-summary-scrolling-not-meeting"> 
                            {props.physician.currentCCEnrollment.activeEnrollmentCertificates.map((enrollmentCertificate: EnrollmentCertificate) => {
                                let certificate = getCertificateFromEnrollmentCertificate(enrollmentCertificate);
                                return(
                                    <Row>
                                        <Col className="text-center">
                                            <div className="pp-font-size-smaller">
                                                <span>{certificate.certificationName}</span>
                                            </div>
                                        </Col>
                                        <Col className="text-center">
                                            <div className="pp-font-size-smaller">
                                                <span>{getPathwayName(enrollmentCertificate)}</span>
                                            </div>
                                        </Col>
                                        <Col className="text-right">
                                            <div className="pp-font-size-smaller">
                                                <span>{getDueByYear(enrollmentCertificate)}{nbsp}{nbsp}{nbsp}{nbsp}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                )})
                            }
                        </div>
                    }
                </div>
            </div>
        </Fragment>
    );
}